import React, {useEffect, useState} from "react";
import Header from "../components/header/header";
import SidebarProvider from "../components/sidebar/sidebar";
import styles from '../../styles/main.module.css';
import Title from "../../components/title/title";
import {PrimaryButton, SelectInput, TextInput} from "../../components/input/inputs";
import {downloadExcel} from "../../utils/utils";
import Loading from "../../components/loading/loading";
import TableComponent from "../../components/table/table";
import {DateInput as DateInputAjonjolib} from "../../components/ajonjolib/inputs/ajonjolinput";
import {evalToString, financingStatusToString, pagoToString,} from "../../utils";
import axiosInstance from "../../AxiosInstance";
import { openFinancingAccept, openFinancingRequest } from "../../modals/bus/modalApi";

export default function FinancingScreen() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [secondaryQuery, setSecondaryQuery] = useState("");
    const [rows, setRows] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [form, setForm] = useState({});

    const cols = [
        {title: "Fecha emisión" , internal: "issue_date"},
        {title: "Serie - Número", internal: "sn"},
        {title: "Cliente", internal: "purchase_order.client.name", code: (row, data) => {
            return (
                <div>
                    <div>{row.purchase_order.client.ruc}</div>
                    <div>{row.purchase_order.client.name}</div>
                </div>
            )
            }
        },
        {title: "Monto Total", internal: "total"},
        {title: "Moneda", internal: "currency.name"},
        {title: "Estado Solicitud", internal: "financing_status", code: (row, data) => {
            return financingStatusToString(data);
            }},
        {title: "Estado Evaluación", internal: "eval_status", code: (row, data) => {
                return <div>{evalToString(data)}</div>;
            }},
        {title: "Estado Pago", internal: "payment_status", code: (row, data) => {
                return <div>{pagoToString(data)}</div>;
            }},
        {title: "Acciones", internal: "id", code: (row, data) => {
            if(row.financing_status === 0) return <div role={'button'} className={styles.pill} style={{backgroundColor: "#2F9636"}} onClick={() => {
                openFinancingRequest({ selectedInvoice: row });
            }}>Solicitar</div>;
            else if(row.financing_status === 1) return <div role={'button'} className={styles.pill} style={{backgroundColor: "#FFF", color: '#333', border: '1px solid #333'}} onClick={() => {
                openFinancingAccept({ selectedInvoice: row });
            }}>Detalles</div>;
            }}
    ];

    useEffect(() => {
        axiosInstance.get('financing/').then((response) => {
            setRows(response.data.results);
            setFilteredRows(response.data.results);
        })
    }, [])

    const query = () => {
        const queryParams = Object.entries(form)
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join("&");
        const url = `financing/?${queryParams}`;
        axiosInstance.get(url).then((response) => {
            setRows(response.data.results);
            setFilteredRows(response.data.results);
        })
    }

    useEffect(() => {
        if(secondaryQuery === undefined || secondaryQuery === "") setFilteredRows(rows);
        const lowerCaseQuery = secondaryQuery.toLowerCase();
        const filtered = rows.filter((row) => {
            return (row?.sn?.toString()?.toLowerCase().includes(lowerCaseQuery)
                || row?.purchase_order?.client?.name?.toLowerCase().includes(lowerCaseQuery)
                || row?.total?.toString().toLowerCase().includes(lowerCaseQuery)
                || row?.total?.toString().toLowerCase().includes(lowerCaseQuery));
        })
        setFilteredRows(filtered);
    }, [secondaryQuery, rows]);

    return (
        <div className={styles.mainContainer}>
            <Header setSidebarOpen={setSidebarOpen}/>
            <SidebarProvider isOpen={sidebarOpen} index={7}/>

            <div className={styles.container} style={!sidebarOpen ? {marginLeft: '80px'} : {marginLeft: '285px'}}>
                <Title name={'Pedir Financiemiento'}/>

                <div className={`${styles.filterContainer} mb-3`}>
                    <div className={'mb-3'}>Filtros</div>

                    <div className={'d-flex w-100'}>
                        <div className={'d-flex flex-column'}
                             style={{flexBasis: '20%', marginRight: "1%"}}>
                            <TextInput placeholder={'Serie'} internalName={'sn'} form={form}
                                       setForm={setForm} hideName={true}/>
                            <DateInputAjonjolib placeholder={'Fecha de emisión'} onChange={(data) => {
                                setForm({
                                    ...form,
                                    'issue_date': data.startDate.toLocaleString('es')?.split(',')[0].replace(/\//g, '-'),
                                    'issue_date_end': data.endDate.toLocaleString('es')?.split(',')[0].replace(/\//g, '-')
                                })
                            }}/>
                        </div>

                        <div className={'d-flex flex-column'}
                             style={{flexBasis: '20%', marginRight: "1%"}}>
                            <TextInput placeholder={'Número'} internalName={'sn_number'} form={form}
                                       setForm={setForm} hideName={true}/>
                            <DateInputAjonjolib placeholder={'Fecha de vencimiento'} onChange={(data) => {
                                setForm({
                                    ...form,
                                    'expiry_date': data.startDate.toLocaleString('es')?.split(',')[0].replace(/\//g, '-'),
                                    'expiry_date_end': data.endDate.toLocaleString('es')?.split(',')[0].replace(/\//g, '-')
                                })
                            }}/>
                        </div>

                        <div className={'d-flex flex-column'}
                             style={{flexBasis: '20%', marginRight: "1%"}}>
                            <TextInput placeholder={'R.U.C. Cliente'} internalName={'ruc'} form={form}
                                       setForm={setForm} hideName={true}/>
                            <SelectInput greyBackground={true} placeholder={'Estado Factoring'}
                                         internalName={'financing_status'} form={form}
                                         setForm={setForm} hideName={true}
                                         options={[{id: 0, name: 'Sin Solicitar'}, {id: 1, name: 'Solicitado'}]}/>
                        </div>

                        <div className={'d-flex flex-column'}
                             style={{flexBasis: '20%', marginRight: "1%"}}>
                            <TextInput placeholder={'Nombre Cliente'} internalName={'client_name'} form={form}
                                       setForm={setForm} hideName={true}/>
                            <SelectInput greyBackground={true} placeholder={'Estado pago'}
                                         internalName={'payment_status'} form={form}
                                         setForm={setForm} hideName={true}
                                         options={[{id: 0, name: 'Pendiente'}, {id: 1, name: 'Pagado'}]}/>
                        </div>

                        <div className={'d-flex flex-column'}
                             style={{flexBasis: '20%', marginRight: "1%"}}>
                            <TextInput placeholder={'Monto'} internalName={'total'} form={form}
                                       setForm={setForm} hideName={true}/>
                            <SelectInput greyBackground={true} placeholder={'Moneda'} internalName={'currency'}
                                         form={form}
                                         setForm={setForm} hideName={true}
                                         options={[{id: 1, name: 'Soles'}, {id: 2, name: 'Dólares'}, {
                                             id: 3,
                                             name: "Euros"
                                         }]}/>
                        </div>
                    </div>

                    <div className={'d-flex justify-content-center mt-1'}>
                        <PrimaryButton variant="quiet" name={'CONSULTAR'} onClick={query}/>
                    </div>
                </div>

                <div className={`my-4 ${styles.secondaryContainer}`}>
                    <div className={'d-flex flex-row align-items-center justify-content-between'}>
                        <div className={'d-flex flex-row'}>
                            <div>Opciones de listado:</div>
                            <div className={styles.downloadButton} onClick={() => downloadExcel()}>Excel</div>
                        </div>
                        <div className={'d-flex align-items-center'}>
                            <div className={'pe-3'}>Buscar:</div>
                            <input className={styles.secondarySearch} value={secondaryQuery} onChange={(event) => {
                                setSecondaryQuery(event.target.value);
                            }}/>
                        </div>
                    </div>
                </div>

                <div className={'pb-5'}>
                    {
                        //Pagination HERE
                        rows.length === 0 ? <Loading/> :
                            <TableComponent
                                withIndex={false} cols={cols}
                                rows={filteredRows} pull={setRows}
                                fetchUrl={'financing'}
                            />
                    }
                </div>
            </div>
        </div>
    )
}
